import axios from 'axios';

export const HTTP = axios.create({
    baseURL: location.origin + atbsPaths.basePath + '/admin/'
});